import styled from 'styled-components'

const UnauthenticatedBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(rgba(38, 55, 70, 0.8), rgba(38, 55, 70, 0.8));
  background-size: cover;
  overflow: auto;
`
const LoginAlignment = styled.div`
  position: relative;
  width: 470px;
  top: 120px;
  margin: 0 auto;
  height: auto!important;
`

const LoginContainer = styled.div`
  position: absolute;
  height: ${props => props.statusText === 'Locked' ? '515px' : '410px'};
  width: 470px;
  padding: 65px 48px 40px 50px;
  background: #fff;
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.07) 0 0 30px 0;
  margin-left: -36px;
  @media (max-width: 1024px) {
   margin-left: -18px;
  }
`

const LoginIcon = styled.div`
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
`

const Logo = styled.img`
  position: absolute;
  top: -50px;
  left: 50%;
  width: 100px;
  height: 100px;
  transform: translateX(-50%);
`

const LockedAccountMessage = styled.div`
  background-color: #F5F5F5;
  color: #666666;
  margin-right: -48px;
  margin-left: -50px;
  margin-bottom: 15px;
  padding: 10px 65px;
  line-height: 1.3em;
  font-size: 15px;
`

export {
  UnauthenticatedBackground,
  LoginAlignment,
  LoginContainer,
  LoginIcon,
  Logo,
  LockedAccountMessage
}
